import { Illustration, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";

import { CallPurposeSection } from "./CallPurposeSection";
import { RecruiterScreeningWarningCallout } from "./RecruiterScreeningWarningCallout";

const MODAL_STACK_SPACING = 10;

interface InitialStepContentProps {
  onCallMeNow: () => void;
  onScheduleLater: () => void;
  isPendingScreening: boolean;
  isNotifyingRecruiter: boolean;
  screeningCalendlyLink?: string;
  showCallMeNow: boolean;
  isScreenFirst: boolean;
  source: "banner" | "detail-cta";
}

function getTitle(params: { source: "banner" | "detail-cta"; isScreenFirst: boolean }): string {
  const { source, isScreenFirst } = params;

  if (source === "banner") {
    return "Schedule a quick phone call";
  }

  return isScreenFirst ? "First step: Quick phone call" : "Last step: Quick phone call";
}

export function InitialStepContent(props: InitialStepContentProps) {
  const {
    onCallMeNow,
    onScheduleLater,
    isPendingScreening,
    isNotifyingRecruiter,
    screeningCalendlyLink,
    showCallMeNow,
    isScreenFirst,
    source,
  } = props;

  const title = getTitle({ source, isScreenFirst });

  return (
    <Stack spacing={MODAL_STACK_SPACING} alignItems="center" justifyContent="center">
      <Illustration type="phone" />

      <Stack spacing={10} alignItems="flex-start">
        <Text variant={isScreenFirst ? "h3" : "h2"} textAlign="center">
          {title}
        </Text>
        <CallPurposeSection />
      </Stack>

      {source !== "banner" && !isScreenFirst && (
        <Stack justifyContent="flex-end" alignItems="center">
          <RecruiterScreeningWarningCallout showCallMeNow={showCallMeNow} />
        </Stack>
      )}

      <Stack spacing={4} alignSelf="stretch">
        {showCallMeNow && (
          <LoadingButton
            fullWidth
            variant="contained"
            size="large"
            isLoading={isNotifyingRecruiter}
            onClick={onCallMeNow}
          >
            Call me now
          </LoadingButton>
        )}

        {!isPendingScreening && (
          <Button
            fullWidth
            variant="outlined"
            size="large"
            disabled={!screeningCalendlyLink}
            onClick={onScheduleLater}
          >
            Schedule the call for later
          </Button>
        )}
      </Stack>
    </Stack>
  );
}
